import 'swiper/swiper-bundle.css';

import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';

import { Swiper } from '@hero/atoms';
import { BannerSkeleton } from '@hero/components/skeletons';
import { getImageDimensions } from '@hero/utils';

import BannerContent from './BannerContent';
import * as S from './style';

function BannerSlider({ banners }) {
  const swiper = useRef();
  const navigate = useNavigate();

  const exampleBannerImage = banners?.[0]?.image?.url;
  const [imageDimensions, setImageDimensions] = useState(null);
  const [showCharityInfoModal, setShowCharityInfoModal] = useState(false);

  const stateList = {
    charity: {
      state: showCharityInfoModal,
      action: setShowCharityInfoModal
    }
  };

  useEffect(() => {
    if (exampleBannerImage) {
      getImageDimensions(exampleBannerImage).then(dimensions => {
        setImageDimensions(dimensions);
      });
    }
  }, [exampleBannerImage]);

  const params = {
    autoplay: {
      delay: 5000, // auto swipe for 2.5 seconds
      disableOnInteraction: false // Set true to disable auto play after user interaction
    },
    breakpoints: {
      1440: {
        slidesPerView: 1
      },
      1200: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 1
      }
    },
    navigation: {
      nextEl: '#collection-slider-next',
      prevEl: '#collection-slider-prev'
    }
  };

  const handleBannerClick = (url, name) => {
    if (url) {
      if (url.includes('http')) {
        window.open(url, '_blank');
      } else {
        navigate(url);
      }
    } else {
      stateList[name].action(true);
    }
  };

  if (!banners?.length || !imageDimensions) {
    return <BannerSkeleton />;
  }

  return (
    <S.BannerSlider ratio={imageDimensions.ratio}>
      <Swiper
        ref={swiper}
        {...params}
        navigation={true}
        pagination={{
          clickable: true
        }}
      >
        {banners?.map(banner => (
          <SwiperSlide key={banner.image?.url}>
            <S.BannerSliderImage
              src={banner.image?.url}
              width="100%"
              onClick={() => handleBannerClick(banner?.url, banner?.title)}
              $isClickable={!!banner?.url || !!stateList[banner?.title]}
              loading="lazy"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <BannerContent
        showCharityInfoModal={showCharityInfoModal}
        setShowCharityInfoModal={setShowCharityInfoModal}
      />
    </S.BannerSlider>
  );
}

BannerSlider.propTypes = {
  banners: PropTypes.array
};

export { BannerSlider };
